import React from "react";
import { Box, Flex, Heading, Image, Text } from "@catchoftheday/cg-components";
import { ASSET_PERSON_CELEBRATING_WITH_CONFETTI } from "../../../../consts";
import { TransferCTAButton } from "../TransferCTAButton";
import { Step } from "./Step";
export const HowToTransfer = () => {
    return (<Flex flexDirection="row-reverse" mb={{
            xs: 16,
            md: 12,
        }} flexWrap="wrap" alignItems="center">
      <Image width={{
            xs: "100%",
            md: "40%",
        }} height="auto" maxWidth={{
            xs: "360px",
            md: "426px",
        }} mr={{
            xs: "auto",
            md: 0,
        }} ml="auto" pb={{
            xs: 0,
            md: 10,
        }} src={ASSET_PERSON_CELEBRATING_WITH_CONFETTI} alt="Person celebrating with confetti in the background"/>
      <Box width={{
            xs: "100%",
            md: "60%",
        }} maxWidth="600px" mx="auto" pr={{
            xs: 0,
            md: 10,
        }} color="onePass.textPrimary">
        <Heading.h2 fontSize="3xl" fontWeight="bold" mb={{
            xs: 4,
            md: 6,
        }}>
          How do I transfer?
        </Heading.h2>
        <Text fontSize="base" fontWeight="medium" m={0} mb={6}>
          To transfer your membership follow the steps below:
        </Text>
        <Box position="relative" mb={6}>
          <Box position="absolute" width="12px" backgroundColor="onePass.primaryLight" top="12px" bottom="12px" left="6px"/>
          <Step step={1} active description={`Click on the "transfer now" link below and login to your Catch Account`}/>
          <Step step={2} description="Complete your details on the OnePass form"/>
          <Step step={3} last description="Pick your subscription plan and follow the instructions to transfer your subscription"/>
        </Box>
        <Text fontSize="base" fontWeight="medium" m={0} mb={6}>
          You are all set! You will now be able to enjoy the additional benefits
          of your OnePass subscription.
        </Text>
        <TransferCTAButton />
      </Box>
    </Flex>);
};
